<template>
    <div class="labor rt-h-screen rt-flex rt-justify-center rt-items-center">
        <div class="rt-w-5/6 rt-rounded-tl-lg rt-rounded-bl-lg
            sm:rt-w-3/5
        ">
            <div class="rt-flex">
                <div class="rt-w-1/2 rt-p-4 rt-bg-white rt-rounded-tl-lg rt-rounded-bl-lg
                    sm:rt-w-3/5
                ">
                    <h1 class="rt-text-2xl rt-font-bold rt-text-red-700 rt-mb-2
                        sm:rt-text-5xl sm:rt-mb-auto"
                    >Labor</h1>
                    <p>The experience and skill level of the installers will impact the price.</p>
                    <img :src="imageUrl" class="rt-my-6"/>
                    <div class="rt-flex rt-justify-center rt-mb-4">
                        <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="prevStep">BACK</button>
                    </div>
                </div>
                <div class="rt-w-1/2 rt-bg-gray-200 rt-p-8 rt-rounded-tr-lg rt-rounded-br-lg
                    sm:rt-w-2/5
                ">
                    <label for="" class="rt-text-gray-600">Choose One: </label>
                    <div class="rt-flex rt-flex-col rt-mt-6">
                        <div class="rt-flex rt-items-center rt-mb-6 group rt-cursor-pointer" @click="selectLabor('unspecialized')" @mouseover="onMouseOver('unspecialized')" @mouseleave="onMouseLeave">
                            <div class="rt-w-1/4 rt-text-center">
                                <span class="rt-inline-block rt-mr-6 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700" :class="{'rt-bg-red-700': laborModel == 'unspecialized'}"></span>
                            </div>
                            <div class="rt-w-3/4">
                                <span class="rt-text-gray-700 group-hover:rt-text-red-700" :class="{'rt-text-red-700': laborModel == 'unspecialized'}">Unspecialized labor team</span>
                            </div>
                        </div>
                        <div class="rt-flex rt-items-center rt-mb-6 group rt-cursor-pointer" @click="selectLabor('factory-certified')" @mouseover="onMouseOver('factory-certified')" @mouseleave="onMouseLeave">
                            <div class="rt-w-1/4 rt-text-center">
                                <span class="rt-inline-block rt-mr-6 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700" :class="{'rt-bg-red-700': laborModel == 'factory-certified'}"></span>
                            </div>
                            <div class="rt-w-3/4">
                                <span class="rt-text-gray-700 group-hover:rt-text-red-700" :class="{'rt-text-red-700': laborModel == 'factory-certified'}">Skilled Manufacturer Certified Crew </span>
                            </div>
                        </div>
                    </div>
                    <div class="rt-flex rt-justify-center rt-mt-8">
                        <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="nextStep">NEXT</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Material',
    computed: {
        stepModel: {
            get() {
                return this.step
            },
            set(value) {
                this.setStep(value)
            }
        },
        laborModel: {
            get() {
                return this.labor
            },
            set(value) {
                this.setLabor(value)
            }
        },
        hoverLaborModel: {
            get() {
                return this.hoverLabor
            },
            set(value) {
                this.setHoverLabor(value)
            }
        },
        ...mapState({
            step: state => state.Common.step,
            labor: state => state.Labor.labor,
            hoverLabor: state => state.Labor.hoverLabor,
        }),
        imageUrl() {
            if(this.hoverLaborModel) {
                return `${window.roofingData.pluginUrl}dist/${require(`@/assets/images/labor-${this.hoverLaborModel}.png`)}`
            }

            return `${window.roofingData.pluginUrl}dist/${require(`@/assets/images/labor-${this.laborModel}.png`)}`
        }
    },
    methods: {
        ...mapMutations("Common", [
            'setStep',
        ]),
        ...mapMutations("Labor", [
            'setLabor',
            'setHoverLabor',
        ]),
        nextStep() {
            this.stepModel = 'quote';
        },
        prevStep() {
            this.stepModel = 'material';
        },
        selectLabor(labor) {
            this.laborModel = labor
        },
        onMouseOver(labor) {
            this.hoverLaborModel = labor
        },
        onMouseLeave() {
            this.hoverLaborModel = null
        },
    }
}
</script>

<style lang="scss" scoped>
    .labor {
        background: #2B2B2B;
    }
</style>